import { TreeNode, TreeNodeType } from "~/components/build/Show/components/Sidebar/TreeNode";

export function createSpacerNode(id: string): TreeNode {
  return {
    id,
    type: TreeNodeType.Spacer,
    render: () => null,
  };
}
